/**
 * @classdesc system系のユーティリティ クラス
 */
export default class SystemUtils{


    /**
     * BenesseBrowser 判定
     * @return {boolean} trueの場合、ベネッセブラウザー
     */
    static get isBenesseBrowser(){
        const ua = navigator.userAgent;
        if(ua.indexOf('BenesseBrowser') > -1){
            return true;
        }
        return false;
    }

    /**
     * CT実機判定
     * @return {boolean} trueの場合、CT実機
     */
    static isCT(){
        const ua = navigator.userAgent;
        const searchStr = /40S404|TAB-A03|TAB-A04|TAB-A05/;
        if(searchStr.test(ua)) return true;
        return false;
    }



    /**
     * iOS判定
     * @return {boolean} trueの場合、iOS
     */
    static get isiOS(){
        const ua = navigator.userAgent;
        const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;
        if(ua.indexOf('iPhone') > -1 || isIPad || ua.indexOf('iPod') > -1){
            return true;
        }
        return false;
    }

    /**
     * Android判定
     * @return {boolean} trueの場合、Android
     */
    static get isAndroid(){
        const ua = navigator.userAgent;
        if(ua.indexOf('Android') > -1){
            return true;
        }
        return false;
    }
}
